import React, { useState, useEffect } from 'react';
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import SinPermisos from '../../Components/SinPermisos/SinPermisos';
import { fetchUsuario, getUsuario } from '../../Components/user';
import { puedeVerMenu } from '../../Helpers/rolesPermisos';
import TalleresData from '../../Components/Admin/TalleresData/TalleresData'
import './Talleres.css';

export default function Talleres() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };
        fetchData();
    }, []);

    const usuarioLegued = getUsuario();
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    {loading ? (
                        <></>
                    ) : usuarioLegued?.idUsuario ? (
                        <>
                            {puedeVerMenu(usuarioLegued.rol, 'talleres') ? (
                                <TalleresData />
                            ) : (
                                <SinPermisos />
                            )}
                        </>
                    ) : (
                        <TalleresData />
                    )}
                </div>
            </section>
        </div>
    )
}


